/* global axios */

// ORIGEM DO CONTATO — de qual dos números da conta o cliente veio (2026-08-06).
//
// O lead é medido por CLIENTE, não por canal: um mesmo telefone que escreveu para três
// caixas é UM contato, e a origem dele é a caixa do PRIMEIRO vínculo. O backend
// (CwCustom::Contacts::OriginReader) só nomeia caixas a que o usuário da requisição tem
// acesso — número privativo de um setor não vaza pela coluna de quem não o opera.
const base = accountId => `/api/v1/accounts/${accountId}/cw_custom`;

export default {
  // contactIds: Array<Number>. Devolve { origens: { [contactId]: {...} } }.
  fetchOrigins(accountId, contactIds) {
    return axios.get(`${base(accountId)}/contact_origins`, {
      params: { contact_ids: contactIds },
    });
  },

  fetchSummary(accountId) {
    return axios.get(`${base(accountId)}/contact_origins/summary`);
  },
};
